import { TableUIProvider } from "../../contexts/TableUIContext";
import Testimonials from "./Testimonials";

export default function TestimonialsWrapper() {
    return (
        <TableUIProvider>
            <Testimonials />
        </TableUIProvider>
    );
}
